<div class="container" id="download-all-component">
  <div class="d-flex flex-column">
    <h3 class="py-3 text-primary-new mt-2"> IEDB Tools: Website Usage</h3>
    <div class="p-3 mb-2 bg-secondary-new">
<!--      <h5 class="text-primary">Complete Download: Entire IEDB Analysis Resource</h5>-->
      <p>
        Data and tools within the IEDB are presented as a public resource and are free to access for all users, including commercial users.
      </p>
    </div>

    <h3 class="py-3 text-primary-new"> IEDB Tools: Download</h3>
    <div class="p-3 mb-2 bg-secondary-new">
      <h5 class="text-primary-new">Complete Download: Entire IEDB Analysis Resource</h5>
      <p>
        For users that would like to run the entire analysis resource locally, a virtual machine image file is available
        with a paid commercial license. The image is kept in sync with the current version of the IEDB Analysis Resource
        and is updated on a six month cycle. Please <a href="mailto: license@iedb.org">contact us</a> for details on
        licensing options.
      </p>
    </div>

    <div class="p-3 mb-2 bg-secondary-new">
      <h5 class="text-primary-new">Standalone Download</h5>
      <p>
        Several of the tools hosted on the IEDB NG Tools website are available as command-line tools, freely available
        to academic users through an open source license. For complete list of all versions of standalone tools used on
        the Legacy or NG Tools websites, click <a href="https://downloads.iedb.org/tools/" target="_blank">here</a>.
      </p>
    </div>

    <div class="py-3 mb-2 bg-white">

      <h3 class="py-3 text-primary-new"> IEDB Tools: License Agreement</h3>
      <select class="mb-3 form-select form-control-lg text-primary-new" [(ngModel)]="selectedTool">
        <option value="mhc-class-i-binding">
          T Cell Prediction - Class I
        </option>
        <option value="mhc-class-ii-binding">
          T Cell Prediction - Class II
        </option>
        <option value="pepmatch">
          Pepmatch
        </option>
        <option value="cluster">
          Cluster
        </option>
        <option value="pepx">
          PepX
        </option>
        <option value="pepcomp">
          Peptide Binding Comparison
        </option>
        <option value="mutgen">
          Mutated Peptide Generator
        </option>
        <option value="phbr">
          Patient Harmonic Mean Best Rank (PHBR)
        </option>
        <option value="classic-linear-b-cell-epitope-predictor">
          Classic: Linear B cell epitope predictor
        </option>
        <option value="classic-mhc-class-i-predictor">
          Classic: MHC class I epitope predictors
        </option>
        <option value="classic-mhc-class-ii-predictor">
          Classic: MHC class II epitope predictors
        </option>
        <option value="classic-ellipro">
          Classic: ElliPro
        </option>
        <option value="classic-cluster">
          Classic: Epitope Cluster Analysis 1.0
        </option>
        <option value="classic-immunogenicity">
          Classic: Class I Immunogenicity
        </option>
        <option value="classic-netchop">
          Classic: Proteasomal Cleavage Prediction
        </option>
        <option value="classic-population">
          Classic: Population Coverage
        </option>
        <option value="classic-tcrmatch">
          Classic: TCRMatch
        </option>
      </select>
      <div class="p-3 mb-2 bg-secondary-new">
        <h5 class="text-primary-new">Description</h5>
        <p class="py-3" *ngIf="selectedTool==='mhc-class-i-binding'">
          This tool wraps up several methods to support the prediction of class I peptide: MHC binding, elution, immunogenicity, and antigen processing.
        </p>
        <p class="py-3" *ngIf="selectedTool==='mhc-class-ii-binding'">
          This tool wraps up several methods to support the prediction of class II peptide: MHC binding, elution, and immunogenicity.
        </p>
        <p class="py-3" *ngIf="selectedTool==='cluster'">
          This tool groups epitopes into clusters based on sequence identity using one of 3 different algorithms.
        </p>
        <p class="py-3" *ngIf="selectedTool==='pepmatch'">
          The PepMatch standalone includes all functionality to scan a list of peptides for closely related sequences in
          custom proteome databases using an ultra-efficient, deterministic algorithm.
        </p>
        <p class="py-3" *ngIf="selectedTool==='pepx'">
          The Peptide eXpression annotator (pepX) takes a peptide as input,
          identifies from which proteins the peptide can be derived, and returns
          an estimate of the expression level of those source proteins from selected
          public databases.
        </p>
        <p class="py-3" *ngIf="selectedTool==='pepcomp'">
          This package is a wrapper around T Cell Class I tool and will run predictors
          from that tool (binding, elution, immunogenicity) on a set of paired peptides
          and compare the results.
        </p>
        <p class="py-3" *ngIf="selectedTool==='mutgen'">
          The Mutant Peptide Generator tool will take a two-sample, SNPEff-annotated VCF as
          input and generate predicted neo-peptides and the reference / WT peptides
          with which they pair.
        </p>
        <p class="py-3" *ngIf="selectedTool==='classic-linear-b-cell-epitope-predictor'">
          This allows for scoring of amino acid residues using the 6 scale-based methods of the linear B cell epitope
          prediction tool.
        </p>
        <p class="py-3" *ngIf="selectedTool==='classic-mhc-class-i-predictor'">
          The MHC_I binding tool contains a collection of the following peptide binding prediction methods for Major
          Histocompatibility Complex (MHC) class I molecules.
        </p>
        <p class="py-3" *ngIf="selectedTool==='classic-mhc-class-ii-predictor'">
          The MHC_II binding tool contains a collection of the following peptide binding prediction methods for Major
          Histocompatibility Complex (MHC) class II molecules.
        </p>
        <p class="py-3" *ngIf="selectedTool==='classic-ellipro'">
          This will produce the same output as the web version of the tool but does not include the initial template
          finding functionality. It accepts either a PDB ID or a path to a PDB file as input. Usage instructions are
          printed by calling the program without any parameters.
        </p>
        <p class="py-3" *ngIf="selectedTool==='classic-cluster'">
          This tool groups epitopes into clusters based on sequence identity. A cluster is defined as a group of
          sequences which have a sequence similarity greater than the minimum sequence identity threshold specified.
        </p>
        <p class="py-3" *ngIf="selectedTool==='classic-immunogenicity'">
          This will produce the same output as the web version of the tool but does not include the initial template
          finding functionality. It accepts either a PDB ID or a path to a PDB file as input. Usage instructions are
          printed by calling the program without any parameters.
        </p>
        <p class="py-3" *ngIf="selectedTool==='classic-netchop'">
          This tool contains methods for NetChop, NetCTL and NetCTLpan. NetChop is a predictor of proteasomal processing
          based upon a neural network. NetCTL is a predictor of T cell epitopes along a protein sequence. It also
          employs a neural network architecture. NetCTLpan is an update to the original NetCTL server that allows for
          prediction of CTL epitope with restriction to any MHC molecules of known protein sequence.
        </p>
        <p class="py-3" *ngIf="selectedTool==='classic-population'">
          This tool calculates the fraction of individuals predicted to respond to a given epitope set on the basis of
          HLA genotypic frequencies and on the basis of MHC binding and/or T cell restriction data. HLA allele genotypic
          frequencies were obtained from <a href="https://www.allelefrequencies.net/" target="_blank">Allele Frequency
          database</a>.
        </p>
        <p class="py-3" *ngIf="selectedTool==='classic-tcrmatch'">
          TCRMatch compares input CDR3b sequences against curated CDR3b sequences in the IEDB to find matches that are
          predicted to share epitope specificity. Matches are determined by sequence similarity, which is scored using a
          comprehensive k-mer comparison.
        </p>
        <p class="py-3" *ngIf="selectedTool==='phbr'">
          The <a href="/pipeline?tool=phbr" target="_blank">Patient Harmonic-mean Best Rank (PHBR)</a> tool takes in a list of neoepitopes and a set of HLA alleles for a single patient.
        Each peptide will be run through class I and/or class II binding predictions and scored according to the harmonic mean of their ranks across the panel of alleles.  Lower PHBR scores indicate a higher likelihood of response to immunotherapy.
        </p>
        <h5 class="text-primary-new">License Agreements </h5>
        <p class="py-3">
          All standalone tools are distributed under the <a href="javascript:void(0);" (click)="downloadNonProfit()">Non-Profit Open Software License (Non-Profit OSL) version 3.0.</a>
          Some tools, developed in coordination with the Technical University of Denmark, are distributed with <a href="javascript:void(0);" (click)="downloadDTU()"> additional
          terms and conditions</a>. By downloading the tools, you are implicitly agreeing to the terms of all applicable
          licenses.
        </p>
      </div>

      <a type="button" class="mt-2 btn btn-sky-blue btn-lg text-white" (click)="onAgreeAndDownload()">
        Agree and Download
      </a>
    </div>

  </div>
</div>
